import { Trash, User } from "lucide-react";
import { deleteuser, userlist } from "../../services/mainService";
import { useEffect, useState } from "react";

const users = [
  {
    id: 1,
    name: "Aisha Khan",
    email: "aisha@gmail.com",
    role: "Donor",
    joined: "10 Jan 2026",
  },
  {
    id: 2,
    name: "Mohammed Ali",
    email: "ali@gmail.com",
    role: "allcause Creator",
    joined: "12 Jan 2026",
  },
];

const UsersList = () => {
  const [users, setUsers] = useState([]);
  const [pagination, setpagination] = useState({
    current_page: 1,
    per_page: 10,
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchuser();
  }, []);

  const fetchuser = async () => {
    try {
      const res = await userlist({ page: pagination.current_page });
      console.log(res);

      setUsers(res.data);
      setpagination(res.pagination_info);
    } catch (err) {
      console.error("Error fetching causes:", err);
    } finally {
    }
  };
  const handledelete = async (id) => {
    try {
      const res = await deleteuser({ user_id: id });
      fetchuser();
    } catch (err) {
      console.error("Error fetching causes:", err);
    } finally {
    }
  };

  return (
    <div className="allcause-page">
      <header className="page-header">
        <h2>Users</h2>
        <p>All registered platform users</p>
      </header>

      <div className="allcause-card">
        <table className="allcause-table">
          <thead>
            <tr>
              <th>User</th>
              <th>Email</th>
              <th>Phone Number</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
            {users.map((user) => (
              <tr key={user.id}>
                <td className="user-cell">
                  <User size={16} /> {user.fullname}
                </td>
                <td>{user.email}</td>

                <td>{user.phone_number}</td>
                <td>
                  <Trash
                    style={{ color: "red", width: "18", cursor: "pointer" }}
                    onClick={() => handledelete(user.id)}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default UsersList;
